'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.fileTimestampWidget = function (metadataSynchroniser) {
	return mmWidgets.each(this, function () {
		const widget = this;
		metadataSynchroniser.addEventListener('event-upload-success', () => {
			widget.removeClass('hidden');
			widget.find('[data-mm-role=time]').text(new Date().toLocaleString());
		});
	});
};
